import React, { useEffect, useState } from 'react'
import * as $ from 'jquery'
import { ModalFormWrapper } from '../../../../../../../../../../itrust_common/components/others'

const FORM_NAME = 'EyeMedSelectLabForm'

const labKey = (lab = {}) => lab.account || ''

function LabDetails({ lab }) {
  if (!lab) return null
  return (
    <div>
      <div className="mb-2">Name: <span className="font-weight-bold">{lab.name || '-'}</span></div>
      <div className="mb-2">Account: <span className="font-weight-bold">{lab.account || '-'}</span></div>
      <div className="mb-2">Ship To: <span className="font-weight-bold">{lab.ship_to || '-'}</span></div>
    </div>
  )
}

export default function LaboratoryInformation({ labs, selectedLab, onSelectLab }) {
  const [showModal, setShowModal] = useState(false)
  const [tempKey, setTempKey] = useState('')
  const lab = selectedLab || labs[0]

  useEffect(() => {
    const $modal = $(`#${FORM_NAME}-modal`)
    if (showModal) {
      setTempKey(labKey(lab || labs[0]))
      $modal.modal('show')
    } else {
      $modal.modal('hide')
    }
  }, [showModal])

  const closeModal = () => {
    $(`#${FORM_NAME}-modal`).modal('hide')
    setShowModal(false)
  }

  const handleContinue = () => {
    const next = labs.find((item) => labKey(item) === tempKey) || labs[0]
    onSelectLab(next)
    closeModal()
  }

  return (
    <div className="mb-4">
      <h5 className="mb-4 font-weight-bold">Laboratory Information</h5>
      <div className="d-flex align-items-start justify-content-between">
        <LabDetails lab={lab} />
        <button type="button" className="btn btn-outline-primary ml-4" onClick={() => setShowModal(true)}>
          Change Lab
        </button>
      </div>

      <div className="inner-modal">
        <ModalFormWrapper
          formName={FORM_NAME}
          hideHeader
          modalSize="modal-lg"
          modalContentClasses="border-0 rounded shadow-lg"
          handleEditCancel={closeModal}
        >
          <div className="modal-header align-items-center border-bottom">
            <h5 className="text-dark mb-0">Select a Lab</h5>
            <div className="d-flex flex-row">
              <button type="button" className="btn btn-outline-secondary mr-7" onClick={closeModal}>
                Cancel
              </button>
              <button type="button" className="btn btn-primary" onClick={handleContinue}>
                Continue
              </button>
            </div>
          </div>

          <div className="px-6 pb-6 mt-6">
            <div className="border rounded p-4">
              {labs.map((item) => {
                const key = labKey(item)
                return (
                  <div key={key} className="radio-btn mb-4">
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        id={`select-lab-${key}`}
                        name="select-lab"
                        className="custom-control-input"
                        checked={tempKey === key}
                        onChange={() => setTempKey(key)}
                      />
                      <label className="custom-control-label pt-1" htmlFor={`select-lab-${key}`}>
                        <LabDetails lab={item} />
                      </label>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </ModalFormWrapper>
      </div>
    </div>
  )
}
